module.exports = __webpack_public_path__ + "static/media/logo_white.2f69da5c.svg";